/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Search/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import Patient from './Patient/index'
import Professional from './Professional/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Search({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/New/Confirm/Content/Referral/Value/Search"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let newReferralFreeTypeValueData = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'free_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: newReferralFreeTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Patient'}>
<Patient
  viewPath={`${viewPath}/Patient`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Professional'}>
<Professional
  viewPath={`${viewPath}/Professional`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}